import { render, staticRenderFns } from "./settlementReject.vue?vue&type=template&id=4c7eb79c"
import script from "./settlementReject.vue?vue&type=script&lang=ts"
export * from "./settlementReject.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports